import { type Static, Type } from "@sinclair/typebox"
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema } from "./common"

export const PlayerRoleSchema = Type.Union([
  Type.Literal("player"),
  Type.Literal("admin"),
])

export type PlayerRole = Static<typeof PlayerRoleSchema>

export const InviteStatusSchema = Type.Union([
  Type.Literal("invited"),
  Type.Literal("bootstrap_admin"),
])

export type InviteStatus = Static<typeof InviteStatusSchema>

export const PlayerProfileSchema = Type.Object({
  id: IdSchema,
  email: NonEmptyStringSchema,
  gamerTag: NonEmptyStringSchema,
  gamerTagNormalized: NonEmptyStringSchema,
  displayName: Type.Optional(NonEmptyStringSchema),
  friendCode: Type.Optional(NonEmptyStringSchema),
  role: PlayerRoleSchema,
  inviteStatus: InviteStatusSchema,
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
})

export type PlayerProfile = Static<typeof PlayerProfileSchema>

export const PlayerProfileStoreSchema = Type.Record(
  Type.String(),
  PlayerProfileSchema,
)

export type PlayerProfileStore = Static<typeof PlayerProfileStoreSchema>

export const GamerTagRegistrySchema = Type.Record(
  Type.String(),
  NonEmptyStringSchema,
)

export type GamerTagRegistry = Static<typeof GamerTagRegistrySchema>
